import { Calculator } from '@/components/Calculator';

export function Beregner() {
  return <Calculator />;
}
